// Parsec Cloud (https://parsec.cloud) Copyright (c) AGPL-3.0-only 2016-present Scille SAS

import SsoProviderCard from '@/components/devices/SsoProviderCard.vue';

export { SsoProviderCard };
